import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import OrderHeader from '../Order/OrderHeader/OrderHeader';

const ManageServices = () => {
    const [services, setServices] = useState([])
    useEffect(() => {
        fetch('https://assignment-11-samiun.herokuapp.com/services')
        .then(res => res.json())
        .then(data => setServices(data))
    }, [services])

    const deleteService = (id) => {
        fetch('https://assignment-11-samiun.herokuapp.com/deleteService/' + id, {
            method: "DELETE"
        })
    }
    return (
        <div className="row">
        <div className="col-md-2">
            <OrderHeader/>
        </div>
        <div className="col-md-10 mt-4">
        <div className="d-flex justify-content-between">
            <h3 className="mb-2">Make Admin</h3>
        </div>
            <div className="mt-3 ps-5 pt-5" style={{background: '#F4F7FC', height: '100vh'}}>
            <div className="p-4 container" style={{background: 'white', height: '100vh'}}>
          <div className="row pt-3 ps-2 " style={{background: 'whitesmoke', borderRadius: '10px'}}>
              <p className="col-md-3">Name</p>
              <p className="col-md-3">Price</p>
              <p className="col-md-3">Action</p>
          </div>
          <div className="row ">
              <div className="mt-3 col-md-3">
                  {
                      services.map(service => <p className="mb-5">{service.title}</p>)
                  }
              </div>
              <div className="mt-3 col-md-3">
                  {
                      services.map(service => <p className="mb-5">${service.price}</p>)
                  }
              </div>
              <div className="mt-3 col-md-3">
                  {
                      services.map(service => <button className="btn btn-danger d-block" style={{marginBottom: '35px'}} onClick={() => deleteService(service._id)}><FontAwesomeIcon icon={faTrash} className="d-block" size="lg"/></button>)
                  }
              </div>
          </div>  
          </div>
          </div>
            </div>
        </div>
    );
};

export default ManageServices;